import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"

import api from "assets/services/api";


function ModalAddSell(props) {

    const [br, setBR] = useState(false);

    const [deliverymanname, setDeliverymanName] = useState();
    const [deliveryusername, setDeliveryusername] = useState();
    const [password, setPassword] = useState();
    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);


    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);


    async function handleAddSell(e) {
        e.preventDefault();
        const response = await api.post('/deliveryman', {
            deliverymanname: deliverymanname,
            deliveryusername: deliveryusername,
            password: password,
            id_admin: storageId
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.getAllDeliverymans();
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar entregador
          </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddSell}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control onChange={event => setDeliverymanName(event.target.value)} type="text" placeholder="Nome do entregador" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridUsername">
                            <Form.Label>Usuário</Form.Label>
                            <Form.Control onChange={event => setDeliveryusername(event.target.value)} type="text" placeholder="Usuário do login" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Senha</Form.Label>
                            <Form.Control onChange={event => setPassword(event.target.value)} type="password" placeholder="Senha do entregador" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Adicionar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Entregador adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddSell;